<odl-checkbox [checked]="enabled()" [disabled]="disabled()" (odl-input)="toggleEnabled($event)">
  {{ 'QUESTIONS.ADD_SKILLS' | translate }}
</odl-checkbox>

@if (enabled()) {
  <div class="competency-chips">
    @for (competency of visibleCompetencies(); track competency._id) {
      <odl-toggle-chip
        #chip
        [checked]="selectedIds().has(competency._id)"
        [disabled]="disabled()"
        (odl-input)="onChipInput(competency._id, chip)"
      >
        {{ competency.translation || competency.name }}
      </odl-toggle-chip>
    }
    @if (hasHiddenCompetencies()) {
      <odl-button
        variant="text"
        [id]="showAllButtonId"
        [description]="'QUESTIONS.SHOW_ALL_SKILLS' | translate"
        [disabled]="disabled()"
        (click)="showAll()"
      >
        <odl-icon name="add_circle" slot="only-icon"></odl-icon>
      </odl-button>
    }
  </div>

  @if (hasHiddenCompetencies()) {
    <odl-tooltip [attr.for]="'#' + showAllButtonId">
      {{ 'QUESTIONS.SHOW_ALL_SKILLS' | translate }}
    </odl-tooltip>
  }
}
